import bFormCheckbox from 'bootstrap-vue/es/components/form-checkbox/form-checkbox';

var pyFormCheckbox = {
  name: 'pyFormCheckbox',
  extends: bFormCheckbox
};

export default pyFormCheckbox;


